/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { UserRole, UserRoleFromJSON, UserRoleFromJSONTyped, UserRoleToJSON } from "./UserRole";

/**
 *
 * @export
 * @interface ProjectRole
 */
export interface ProjectRole {
  /**
   *
   * @type {number}
   * @memberof ProjectRole
   */
  projectId?: number;
  /**
   *
   * @type {UserRole}
   * @memberof ProjectRole
   */
  role?: UserRole;
}

export function ProjectRoleFromJSON(json: any): ProjectRole {
  return ProjectRoleFromJSONTyped(json, false);
}

export function ProjectRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRole {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    projectId: !exists(json, "projectId") ? undefined : json["projectId"],
    role: !exists(json, "role") ? undefined : UserRoleFromJSON(json["role"]),
  };
}

export function ProjectRoleToJSON(value?: ProjectRole | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    projectId: value.projectId,
    role: UserRoleToJSON(value.role),
  };
}
